module.exports = __webpack_public_path__ + "static/media/ITC-TMI-2021-MarketAnalysisTools-PostCard-Spanish.021e14e6.pdf";